import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';
import { initGA4 } from '../lib/ga4';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Delay showing the banner slightly for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    } else if (consent === 'accepted') {
      initGA4();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
    initGA4();
  };

  const handleRefuse = () => {
    localStorage.setItem('cookie_consent', 'refused');
    setIsVisible(false);
  };

  const handleCustomize = () => {
    // For now, same as refuse - could open modal for granular control
    localStorage.setItem('cookie_consent', 'customized');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 animate-fade-in"
      role="dialog"
      aria-labelledby="cookie-title"
      aria-describedby="cookie-description"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex-1">
            <h3 id="cookie-title" className="text-base font-semibold text-gray-900">
              Respect de votre vie privée
            </h3>
            <p id="cookie-description" className="mt-1 text-sm text-gray-600">
              Nous utilisons des cookies pour analyser notre trafic et améliorer votre expérience. 
              Vous pouvez accepter, refuser ou personnaliser vos préférences à tout moment.{' '}
              <a href="#confidentialite" className="text-blue-700 hover:underline">
                En savoir plus
              </a>
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handleCustomize}
              data-testid="cookie-customize-btn"
              className="text-gray-600 border-gray-300 hover:bg-gray-50"
            >
              Personnaliser
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleRefuse}
              data-testid="cookie-refuse-btn"
              className="text-gray-600 border-gray-300 hover:bg-gray-50"
            >
              Refuser
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              data-testid="cookie-accept-btn"
              className="bg-blue-700 hover:bg-blue-800 text-white"
            >
              Accepter tout
            </Button>
          </div>
          
          <button
            onClick={handleRefuse}
            className="absolute top-2 right-2 md:hidden p-1 text-gray-400 hover:text-gray-600"
            aria-label="Fermer"
            data-testid="cookie-close-btn"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
